module.exports = __webpack_public_path__ + "static/media/ldcoffee.c31fbd22.webp";